import React from 'react';
import HiddenInput from 'shared/components/HiddenInput';

const EmailHidden = (props) => {
  const { parameters, groupName } = props;
  const name = 'email';
  return (
    <HiddenInput
      name={name}
      value={parameters[name]}
      groupName={groupName} />
  );
};

export default EmailHidden;
